import { useEffect } from "react";
import _ from "lodash";

import type { TicketEmailAutoResponseDecisionDto } from "@src/api-new/generated-api.schemas";

import type { NormalizedCustomerDto } from "../../helpers/normalizeCustomerDto";
import ENV from "../../constants/ENV";



interface ChatymeSettings {
    chatbotId: string;
    userId?: string | number;
    firstName?: string;
    lastName?: string;
    dataDictionary?: Record<string, string | number | undefined>;
}

interface ChatymeProps {
    customerDetails: NormalizedCustomerDto,
    token: string,
    /* contextValues: TicketEmailAutoResponseDecisionDto; */
}

const CHATYME_BOT_ID = "cp4BZkcSIHn1Vdq8rNoyH0GFLNLyDsDs";
const CHATYME_CLIENT_APP_URL = ENV.CHATYME_CLIENT_APP_URL;
const CHATYME_CHAT_APP_URL = ENV.CHATYME_CHAT_APP_URL;

export default function Chatyme(props: ChatymeProps) {
  const {
    customerDetails,
    token
    /* contextValues */
  } = props;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `${CHATYME_CLIENT_APP_URL}/chatyme.js?v=${new Date().getTime()}`;
    script.dataset.client_app_url = CHATYME_CLIENT_APP_URL; // data attribute (should include protocol)
    script.dataset.chat_app_url = CHATYME_CHAT_APP_URL; // data attribute (should include protocol)
    script.dataset.chat_overlay = "client";

    const chatData = {
      config: {
        screen_type: "client",
        bot_id: CHATYME_BOT_ID,
        language: "es", // Can be changed to "tr" or "es"
        locale: "es-ES", // Can be changed to "tr-TR" or "es-ES"
        file_upload_path: `${customerDetails.id}/{{session_id}}_{{message_id}}_{{file_name}}`,
        user: {
          name: customerDetails.firstName,
          surname: customerDetails.lastName,
          email: customerDetails.email,
          role: "client",
          external_user_id: customerDetails.id
        },
        session: {
          client_profile_url: `${ENV.BACKOFFICE_URL}/customer-list/${customerDetails.id}/personal-details`
        }
      },
      env: {
        EXTERNAL_API_TOKEN: token
      }/*,
      context: {
        ...contextValues
      }*/
    };

    script.setAttribute("data-chat", JSON.stringify(chatData));
    document.body.appendChild(script);

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "CHAT_TOKEN_EXPIRED") {
        // TODO: Handle token expired
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [ token, customerDetails ]); /* contextValues */

  return null;
}
